import { MenuItem, TextField } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useUpdateNomenklaturaMutation } from "../../../store/nomenklaturaApi";
import { useGetCategoriesQuery } from "../../../store/coefficientsApi/categoryApi";
import { useGetK2Query } from "../../../store/coefficientsApi/k2Api";
import { useGetK1Query } from "../../../store/coefficientsApi/k1Api";
import { useGetK4Query } from "../../../store/coefficientsApi/k4Api";
import ScrollDialog from "../../UI/ScrollModal";
import FileUploadButton from "../../UI/FileUploadButton";
import { backUrl } from "../../../config";
import { useSelector } from "react-redux";
import Files from "../../UI/Files";

export default function Nomenklatura({ item, onClose, id }) {
  const { accessToken } = useSelector((state) => state.auth);
  const { data: categoryFB } = useGetCategoriesQuery();
  const { data: k1FB } = useGetK1Query("?sort[0]=id:asc");
  const { data: k2FB } = useGetK2Query("?sort[0]=id:asc");
  const { data: k4FB } = useGetK4Query("?sort[0]=id:asc");
  const [updateNomenklatura] = useUpdateNomenklaturaMutation();
  const [listOfCategories, setListOfCategories] = React.useState([]);
  const [category, setCategory] = React.useState(item.category.data[0].id);
  const [name, setName] = React.useState(item.name);
  const [address, setAddress] = React.useState(item.address);
  const [inventNumber, setInventNumber] = React.useState(item.inventNumber);
  const [addressNumber, setAddressNumber] = React.useState(item.addressNumber);
  const [square, setSquare] = React.useState(item.square);
  const [listOfK1, setListOfK1] = React.useState([]);
  const [k1, setK1] = React.useState(item.k1.data[0].id);
  const [listOfK2, setListOfk2] = React.useState([]);
  const [k2, setK2] = React.useState(item.k2.data[0].id);
  const [listOfK4, setListOfK4] = React.useState([]);
  const [k4, setK4] = React.useState(item.k4.data[0].id);
  const [coordinates, setCoordinates] = React.useState(item.coordinates);
  const [filesIsOpen, setFilesIsOpen] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [uploadedFiles, setUploadedFiles] = React.useState([]);

  const attachments = item.attachments ? item.attachments : [];

  const handleFileChange = (files) => {
    setSelectedFiles(files);
  };

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const categories = await categoryFB.data;
        const k2s = await k2FB.data;
        const k1s = await k1FB.data;
        const k4s = await k4FB.data;
        setListOfCategories(categories);
        setListOfk2(k2s);
        setListOfK1(k1s);
        setListOfK4(k4s);
      } catch (error) {}
    };
    setDataToStates();
  }, [categoryFB, k2FB, k1FB, k4FB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const updated = {
      name,
      address,
      inventNumber,
      addressNumber,
      square,
      coordinates,
      category,
      k1,
      k2,
      k4,
      attachments: uploadedFiles.concat(attachments),
    };
    updateNomenklatura({ updated, id });
    onClose();
  };

  const FormUploadFileHandler = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("files", selectedFiles[i]);
      }
    }

    try {
      const response = await fetch(`${backUrl}upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        setUploadedFiles(responseData);
        console.log("Upload successful:", responseData);
      } else {
        console.error("Upload failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfContragent>Карточка объекта</TitleOfContragent>
      <BlockStyled
        margin="0 0 20px 0"
        width="100%"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Наименование"
          variant="outlined"
          value={name}
          onChange={(event) => inputChangeHandler(event, setName)}
          width="48%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Идентификационный код"
          variant="outlined"
          value={inventNumber}
          onChange={(event) => inputChangeHandler(event, setInventNumber)}
          width="30%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Площадь"
          variant="outlined"
          value={square}
          onChange={(event) => inputChangeHandler(event, setSquare)}
          width="20%"
        />
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
          width="40%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="№"
          variant="outlined"
          value={addressNumber}
          onChange={(event) => inputChangeHandler(event, setAddressNumber)}
          width="12%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Координаты"
          variant="outlined"
          value={coordinates}
          onChange={(event) => inputChangeHandler(event, setCoordinates)}
          width="45%"
        />
      </BlockStyled>

      <BlockStyled margin="0 0 20px 0">
        <TextFieldStylded
          id="select"
          select
          label="Категория"
          variant="outlined"
          width="100%"
          value={listOfCategories.length ? category : ""}
        >
          {listOfCategories.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setCategory(item.id)}
              >
                {item.attributes.name}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="select"
          select
          label="Коэффициент коммерческого использования"
          variant="outlined"
          value={listOfK2.length ? k2 : ""}
          width="100%"
        >
          {listOfK2.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK2(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="select"
          select
          label="Коэффициент определяемый от месторасположения участка"
          variant="outlined"
          value={listOfK1.length ? k1 : ""}
          width="100%"
        >
          {listOfK1.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK1(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="select"
          select
          label="Коффициент определяемый от общей площади предоставляемого земельного участка"
          variant="outlined"
          value={listOfK4.length ? k4 : ""}
          width="100%"
        >
          {listOfK4.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setK4(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
      </BlockStyled>
      <BlockStyled display="flex" justifyContent="flex-end">
        <ScrollDialog
          open={filesIsOpen}
          closeModal={() => setFilesIsOpen(false)}
          save={formSubmitHandler}
          title="Файлы"
          isChangedData={uploadedFiles.length ? true : false}
          actionButtons={
            <>
              <FileUploadButton
                buttonName={
                  selectedFiles.length
                    ? `Выбрано файлов (${selectedFiles.length})`
                    : `Выбрано файлов (${selectedFiles.length})`
                }
                onFileChange={handleFileChange}
                width="250px"
              />
              <BasicButtons type="submit" onClick={FormUploadFileHandler}>
                Загрузить
              </BasicButtons>
            </>
          }
        >
          <Files uploadedFiles={uploadedFiles} attachments={attachments} />
        </ScrollDialog>
        <BasicButtons onClick={() => setFilesIsOpen(true)}>Файлы</BasicButtons>
        <BasicButtons>
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://maps.google.com?Location&daddr=${coordinates}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            на карте
          </a>
        </BasicButtons>
        <BasicButtons onClick={onClose}>Отменить</BasicButtons>
        <BasicButtons type="submit">Сохранить</BasicButtons>
      </BlockStyled>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const TitleOfContragent = styled.h3`
  text-align: center;
`;
// =========================== Блок кнопок ======================================\\
const StyledForm = styled.form``;
